<template>
  <div>
    <Row style="padding: 20px">
      <Col span="12">
        <Input v-model="params.name" placeholder="请输入名称" class="search" />
        <Button
          type="primary"
          icon="md-search"
          @click="getList"
          v-access="'merchant.list.query'"
          >搜索</Button
        >
        <Button @click="resetList" v-access="'merchant.list.reset'"
          >重置</Button
        >
      </Col>
      <Col span="12">
        <Button
          type="primary"
          icon="md-add"
          class="add"
          @click="create"
          v-access="'merchant.list.add'"
          >添加</Button
        >
        <Button
          type="primary"
          icon="md-cloud-download"
          class="add"
          @click="importHandler"
          >导入</Button
        >
        <Button
          type="primary"
          icon="md-cloud-upload"
          class="add"
          @click="exportHandler"
          >导出</Button
        >
      </Col>
      <Col span="24">
        <Table
          class="table"
          border
          stripe
          :loading="loading"
          :columns="columns"
          :data="shopInfoQueryList.data || []"
        >
          <template slot-scope="{ index }" slot="no">
            <span>{{
              params.pageSize * (params.pageNum - 1) + index + 1
            }}</span>
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <a
              style="margin-right: 5px"
              @click="detail(row, index)"
              v-access="'merchant.list.details'"
              >查看</a
            >
            <a
              type="text"
              size="small"
              style="margin-right: 5px"
              @click="edit(row, index)"
              v-access="'merchant.list.edit'"
              >编辑</a
            >
            <a
              style="margin-right: 5px"
              @click="deletehandler(row, index)"
              v-access="'merchant.list.delete'"
              >删除</a
            >
          </template>
        </Table>
        <Page
          :style="{ float: 'right', marginTop: '10px' }"
          :total="shopInfoQueryList.total"
          show-sizer
          show-total
          prev-text="Previous"
          next-text="Next"
          show-elevator
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
        />
      </Col>
    </Row>
    <Modal
      v-model="deleteModal"
      title="删除提醒"
      @on-ok="deletehandler2"
      @on-cancel="cancelDetele"
    >
      <p>确定删除该条数据吗？</p>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
const columns = [
  {
    title: "序号",
    slot: "no",
    width: 80,
  },
  // {
  //   title: "类型",
  //   key: "stype",
  // },
  {
    title: "经销商分组",
    key: "groupCode",
  },
  {
    title: "主体信息",
    key: "businessInfo",
  },
  {
    title: "渠道编码",
    key: "channelCode",
  },
  {
    title: "服务商等级",
    key: "dealerLevel",
  },
  {
    title: "服务商名称",
    key: "name",
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
export default {
  data() {
    return {
      loading: false,
      columns,
      name: "",
      pageNum: 1,
      pageSize: 10,
      formModel: false,
      formTitle: "",
      queryForm: {},

      params: {
        pageSize: 10,
        pageNum: 1,
        name: "",
        stype: "0",
      },

      deleteModal: false,
      currentRow: null,
    };
  },
  computed: {
    ...mapGetters({
      shopInfoQueryList: "merchant/getShopInfoQueryList",
    }),
  },
  created() {
    this.getList();

    // setTimeout(() => {
    //   console.log(this.shopInfoQueryList)
    // }, 2000)
  },
  methods: {
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("merchant/shopInfoQueryList", this.params)
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 页码
    pageNumChange(pageNum) {
      this.params.pageNum = pageNum;
      this.getList();
    },
    // 页数
    pageSizeChange(pageSize) {
      this.params.pageSize = pageSize;
      // 页码变动触发pageNumChange
      if (this.params.pageNum == 1) {
        this.getList();
      } else {
        this.params.pageNum = 1;
      }
    },
    // 重置
    resetList() {
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.params.name = "";
      this.getList();
    },
    // 添加
    create() {
      this.$router.push({
        path: "create",
        // query:
      });
    },
    // 导入
    importHandler() {},
    // 导出
    exportHandler() {},
    // 详情
    detail(row, index) {
      this.$router.push({
        path: "detail",
        query: {
          code: row.code,
        },
      });
    },
    deletehandler(row, index) {
      this.deleteModal = true;
      this.currentRow = row;
    },
    cancelDetele() {
      this.currentRow = null;
    },
    deletehandler2() {
      if (this.currentRow && this.currentRow.code) {
        const code = this.currentRow.code;
        this.$store
          .dispatch("merchant/shopInfoDel", { code: code })
          .then((res) => {
            if (res.code == 200) {
              this.$Message.success("删除成功");
              this.getList();
            } else {
              this.$Message.error(res.message || "删除失败");
            }
          });
      }
    },
    // 编辑
    edit(row, index) {
      this.$router.push({
        path: "create",
        query: {
          code: row.code,
        },
      });
    },
  },
};
</script>
<style scoped>
.search {
  margin-right: 15px;
  width: 300px;
}
.add {
  float: right;
  margin-right: 0;
  margin-left: 15px;
}
.table {
  margin-top: 10px;
}
.formEach {
  display: flex;
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
}
.formEach > span {
  line-height: 30px;
  width: 80px;
}
.formEach > span::before {
  content: "*";
  color: brown;
}
.formEach > .noq::before {
  opacity: 0;
}
</style>




// WEBPACK FOOTER //
// src/views/merchant/manage/list.vue